<script>
import moment from 'moment';
import momentTz from 'moment-timezone';

export default {
    components: {
        CpButton: require('../button').default,
        CpButtonLink: require('../button-link').default,
        CpDialog: require('../dialog').default,
        CpBoxContent: require('../box-content').default,
        CpBox: require('../box').default,
        CpTextInput: require('../inputs/text').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
    },
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },
    props: {
        closeLiveEventDialog: Function,
        events: Array,
    },
    name: 'CpLiveEventDialog',
    methods: {
        timeAgoEventStart(index) {
            return momentTz.tz(this.events[index].start, "America/New_York").format('MMMM Do, YYYY - h:mm a');
        },
        timeAgoEventEnd(index) {
            return momentTz.tz(this.events[index].end, "America/New_York").format('MMMM Do, YYYY - h:mm a');
        },
        eventDetail(index) {
            return 'groups/' + this.events[index].group_id + '/events/' + this.events[index].event_id
        }
    },
    computed: {
        authUser() {
            return this.$root.authUser;
        },
    },
};
</script>
<template>
    <cp-dialog>
        <cp-box>
            <cp-box-content>
                <section style="margin: 2em 2em; max-width: 40ch">
                    <template class="share-container">
                        <svg
                            @click.prevent="closeLiveEventDialog()"
                            class="close-svg-icon"
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                            ></path>
                        </svg>
                        <h5 class="now-streaming">Now Streaming</h5>
                        <div v-for="(event, index) in events" :key="event.id" class="box-event">
                            <h2 class="event-title">{{ event.title }}</h2>
                            <div class="box-event-details">
                                <div class="box-image-event">
                                    <img :src="event.image" class="image-event" />
                                </div>
                                <div class="box-event-dates">
                                    <div class="event-dates">
                                        <h4 class="start">Start</h4>
                                        <h4 class="event-start">{{ timeAgoEventStart(index) }} EST</h4>
                                    </div>
                                    <div class="event-dates">
                                        <h4 class="end">End</h4>
                                        <h4 class="event-end">{{ timeAgoEventEnd(index) }} EST</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-join">
                                <cp-button-link :href="eventDetail(index)" primary>
                                    Join
                                </cp-button-link>
                            </div>
                        </div>
                    </template>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog>
</template>
<style scoped>
.btn-join {
    text-align: right;
    margin-top: 10px;
}
.image-event {
    object-fit: cover;
    height: 100px;
    width: 100px;
}
.box-event {
    padding: 10px;
    border: 0.5px solid #F3F3F3;
    box-sizing: border-box;
    box-shadow: 3px 3px 10px rgb(229 229 229 / 50%);
    border-radius: 10px;
    margin-bottom: 10px;
    background: white;
    height: auto;
}
.events-container {
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 10px;
    background: #F3F3F3;
}
.box-event-dates {
    display: grid;
}
.start,
.end {
    margin: 0;
    color: #555555;
    font-size: 1em;
    font-weight: normal;
    font-style: italic;
    opacity: 0.8;
}
.event-start,
.event-end {
    color: #555555;
    font-size: 1.17em;
    font-weight: normal;
    margin: 0;
}
.event-dates {
    align-self: center;
}
.box-image-event {
    margin-right: 10px;
}
.box-event-details {
    display: flex;
}
.event-title {
    margin: 0 0 10px 0;
    color: #ED572F;
    font-size: 20px;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.now-streaming {
    border-radius: 5px;
    background: #22bb69;
    color: #fff;
    padding: 5px 4px;
    margin: 0 0 10px 0;
    width: max-content;
}
.close-svg-icon {
    cursor: pointer;
}
</style>
